export const config = {
  apiUrl: process.env.REACT_APP_SERVER_URL || 'http://localhost:8080',
  apiKey: 'sk-proj-ZJoNbrBeTweiMdFKKKA7T3BlbkFJMxDWDxy0cQLVGvKd6Ou9',
}